/* eslint-disable */
import _m0 from "protobufjs/minimal";

export const protobufPackage = "espressif";

export enum WifiStationState {
  Connected = 0,
  Connecting = 1,
  Disconnected = 2,
  ConnectionFailed = 3,
  UNRECOGNIZED = -1,
}

export function wifiStationStateFromJSON(object: any): WifiStationState {
  switch (object) {
    case 0:
    case "Connected":
      return WifiStationState.Connected;
    case 1:
    case "Connecting":
      return WifiStationState.Connecting;
    case 2:
    case "Disconnected":
      return WifiStationState.Disconnected;
    case 3:
    case "ConnectionFailed":
      return WifiStationState.ConnectionFailed;
    case -1:
    case "UNRECOGNIZED":
    default:
      return WifiStationState.UNRECOGNIZED;
  }
}

export function wifiStationStateToJSON(object: WifiStationState): string {
  switch (object) {
    case WifiStationState.Connected:
      return "Connected";
    case WifiStationState.Connecting:
      return "Connecting";
    case WifiStationState.Disconnected:
      return "Disconnected";
    case WifiStationState.ConnectionFailed:
      return "ConnectionFailed";
    case WifiStationState.UNRECOGNIZED:
    default:
      return "UNRECOGNIZED";
  }
}

export enum WifiConnectFailedReason {
  AuthError = 0,
  NetworkNotFound = 1,
  UNRECOGNIZED = -1,
}

export function wifiConnectFailedReasonFromJSON(object: any): WifiConnectFailedReason {
  switch (object) {
    case 0:
    case "AuthError":
      return WifiConnectFailedReason.AuthError;
    case 1:
    case "NetworkNotFound":
      return WifiConnectFailedReason.NetworkNotFound;
    case -1:
    case "UNRECOGNIZED":
    default:
      return WifiConnectFailedReason.UNRECOGNIZED;
  }
}

export function wifiConnectFailedReasonToJSON(object: WifiConnectFailedReason): string {
  switch (object) {
    case WifiConnectFailedReason.AuthError:
      return "AuthError";
    case WifiConnectFailedReason.NetworkNotFound:
      return "NetworkNotFound";
    case WifiConnectFailedReason.UNRECOGNIZED:
    default:
      return "UNRECOGNIZED";
  }
}

export enum WifiAuthMode {
  Open = 0,
  WEP = 1,
  WPA_PSK = 2,
  WPA2_PSK = 3,
  WPA_WPA2_PSK = 4,
  WPA2_ENTERPRISE = 5,
  UNRECOGNIZED = -1,
}

export function wifiAuthModeFromJSON(object: any): WifiAuthMode {
  switch (object) {
    case 0:
    case "Open":
      return WifiAuthMode.Open;
    case 1:
    case "WEP":
      return WifiAuthMode.WEP;
    case 2:
    case "WPA_PSK":
      return WifiAuthMode.WPA_PSK;
    case 3:
    case "WPA2_PSK":
      return WifiAuthMode.WPA2_PSK;
    case 4:
    case "WPA_WPA2_PSK":
      return WifiAuthMode.WPA_WPA2_PSK;
    case 5:
    case "WPA2_ENTERPRISE":
      return WifiAuthMode.WPA2_ENTERPRISE;
    case -1:
    case "UNRECOGNIZED":
    default:
      return WifiAuthMode.UNRECOGNIZED;
  }
}

export function wifiAuthModeToJSON(object: WifiAuthMode): string {
  switch (object) {
    case WifiAuthMode.Open:
      return "Open";
    case WifiAuthMode.WEP:
      return "WEP";
    case WifiAuthMode.WPA_PSK:
      return "WPA_PSK";
    case WifiAuthMode.WPA2_PSK:
      return "WPA2_PSK";
    case WifiAuthMode.WPA_WPA2_PSK:
      return "WPA_WPA2_PSK";
    case WifiAuthMode.WPA2_ENTERPRISE:
      return "WPA2_ENTERPRISE";
    case WifiAuthMode.UNRECOGNIZED:
    default:
      return "UNRECOGNIZED";
  }
}

export interface WifiConnectedState {
  ip4Addr: string;
  authMode: WifiAuthMode;
  ssid: Uint8Array;
  bssid: Uint8Array;
  channel: number;
}

function createBaseWifiConnectedState(): WifiConnectedState {
  return { ip4Addr: "", authMode: 0, ssid: new Uint8Array(), bssid: new Uint8Array(), channel: 0 };
}

export const WifiConnectedState = {
  encode(message: WifiConnectedState, writer: _m0.Writer = _m0.Writer.create()): _m0.Writer {
    if (message.ip4Addr !== "") {
      writer.uint32(10).string(message.ip4Addr);
    }
    if (message.authMode !== 0) {
      writer.uint32(16).int32(message.authMode);
    }
    if (message.ssid.length !== 0) {
      writer.uint32(26).bytes(message.ssid);
    }
    if (message.bssid.length !== 0) {
      writer.uint32(34).bytes(message.bssid);
    }
    if (message.channel !== 0) {
      writer.uint32(40).int32(message.channel);
    }
    return writer;
  },

  decode(input: _m0.Reader | Uint8Array, length?: number): WifiConnectedState {
    const reader = input instanceof _m0.Reader ? input : new _m0.Reader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseWifiConnectedState();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1:
          message.ip4Addr = reader.string();
          break;
        case 2:
          message.authMode = reader.int32() as any;
          break;
        case 3:
          message.ssid = reader.bytes();
          break;
        case 4:
          message.bssid = reader.bytes();
          break;
        case 5:
          message.channel = reader.int32();
          break;
        default:
          reader.skipType(tag & 7);
          break;
      }
    }
    return message;
  },

  fromJSON(object: any): WifiConnectedState {
    return {
      ip4Addr: isSet(object.ip4Addr) ? String(object.ip4Addr) : "",
      authMode: isSet(object.authMode) ? wifiAuthModeFromJSON(object.authMode) : 0,
      ssid: isSet(object.ssid) ? bytesFromBase64(object.ssid) : new Uint8Array(),
      bssid: isSet(object.bssid) ? bytesFromBase64(object.bssid) : new Uint8Array(),
      channel: isSet(object.channel) ? Number(object.channel) : 0,
    };
  },

  toJSON(message: WifiConnectedState): unknown {
    const obj: any = {};
    message.ip4Addr !== undefined && (obj.ip4Addr = message.ip4Addr);
    message.authMode !== undefined && (obj.authMode = wifiAuthModeToJSON(message.authMode));
    message.ssid !== undefined &&
      (obj.ssid = base64FromBytes(message.ssid !== undefined ? message.ssid : new Uint8Array()));
    message.bssid !== undefined &&
      (obj.bssid = base64FromBytes(message.bssid !== undefined ? message.bssid : new Uint8Array()));
    message.channel !== undefined && (obj.channel = Math.round(message.channel));
    return obj;
  },

  create<I extends Exact<DeepPartial<WifiConnectedState>, I>>(base?: I): WifiConnectedState {
    return WifiConnectedState.fromPartial(base ?? {});
  },

  fromPartial<I extends Exact<DeepPartial<WifiConnectedState>, I>>(object: I): WifiConnectedState {
    const message = createBaseWifiConnectedState();
    message.ip4Addr = object.ip4Addr ?? "";
    message.authMode = object.authMode ?? 0;
    message.ssid = object.ssid ?? new Uint8Array();
    message.bssid = object.bssid ?? new Uint8Array();
    message.channel = object.channel ?? 0;
    return message;
  },
};

declare var self: any | undefined;
declare var window: any | undefined;
declare var global: any | undefined;
var tsProtoGlobalThis: any = (() => {
  if (typeof globalThis !== "undefined") {
    return globalThis;
  }
  if (typeof self !== "undefined") {
    return self;
  }
  if (typeof window !== "undefined") {
    return window;
  }
  if (typeof global !== "undefined") {
    return global;
  }
  throw "Unable to locate global object";
})();

function bytesFromBase64(b64: string): Uint8Array {
  if (tsProtoGlobalThis.Buffer) {
    return Uint8Array.from(tsProtoGlobalThis.Buffer.from(b64, "base64"));
  } else {
    const bin = tsProtoGlobalThis.atob(b64);
    const arr = new Uint8Array(bin.length);
    for (let i = 0; i < bin.length; ++i) {
      arr[i] = bin.charCodeAt(i);
    }
    return arr;
  }
}

function base64FromBytes(arr: Uint8Array): string {
  if (tsProtoGlobalThis.Buffer) {
    return tsProtoGlobalThis.Buffer.from(arr).toString("base64");
  } else {
    const bin: string[] = [];
    arr.forEach((byte) => {
      bin.push(String.fromCharCode(byte));
    });
    return tsProtoGlobalThis.btoa(bin.join(""));
  }
}

type Builtin = Date | Function | Uint8Array | string | number | boolean | undefined;

export type DeepPartial<T> = T extends Builtin ? T
  : T extends Array<infer U> ? Array<DeepPartial<U>> : T extends ReadonlyArray<infer U> ? ReadonlyArray<DeepPartial<U>>
  : T extends {} ? { [K in keyof T]?: DeepPartial<T[K]> }
  : Partial<T>;

type KeysOfUnion<T> = T extends T ? keyof T : never;
export type Exact<P, I extends P> = P extends Builtin ? P
  : P & { [K in keyof P]: Exact<P[K], I[K]> } & { [K in Exclude<keyof I, KeysOfUnion<P>>]: never };

function isSet(value: any): boolean {
  return value !== null && value !== undefined;
}
